
export default {
    name: 'ImageThumbnail',
    props: {
        /**
         * An Image object
         */
        image: {
            type: Object,
            required: true,
        },
        /**
         * Should we show the delete button?
         */
        showDelete: {
            type: Boolean,
            deafult: false,
        },
        /**
         * Size in px for the image
         */
        size: {
            type: Number,
            default: 150,
        },
    },
    methods: {
        deleteImage() {
            /**
             * Delete this image
             *
             * @type {null}
             */
            this.$emit('delete-image');
        },
    },
};

